// extracted by mini-css-extract-plugin
module.exports = {"outcomesWrap":"styles_outcomesWrap__vs-4I"};